// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3xt_k","alert":"SettungsInbox_alert__20NJn"};